import React, { useState } from "react";
import { Input } from "@/components/ui/input.tsx";
import { createGroup } from "@/api/offline.ts";
import { addStateEntry, groupsState, uiState } from "@/states.ts";
import { processQueue } from "@/api/queue.ts";
import { Button } from "@/components/ui/button.tsx";
import * as Dialog from "@radix-ui/react-dialog";

const NewGroupDialog: React.FC = () => {
	const [title, setTitle] = useState("");

	const handleCreateGroup = (e: React.SyntheticEvent) => {
		e.preventDefault();
		if (!title) {
			return;
		}
		createGroup(title).then((g) => {
			addStateEntry(groupsState.groups, g.group, true);
			uiState.newGroup = false;
		});
		processQueue();
	};

	const handleClose = () => {
		uiState.newGroup = false;
	};

	return (
		<Dialog.Root open={true}>
			<Dialog.Portal>
				<Dialog.Overlay className="DialogOverlay" />
				<Dialog.Content className={"DialogContent"}>
					<form
						onSubmit={handleCreateGroup}
						className={"p-4 flex flex-col space-y-2"}
					>
						<Dialog.Title className="DialogTitle">
							New Group
						</Dialog.Title>
						<Input
							autoFocus
							placeholder={"Title"}
							value={title}
							className={"bg-secondary/30"}
							onChange={(e) => setTitle(e.target.value)}
						/>
						<div className="flex gap-4 justify-end pt-4">
							<Button
								type={"button"}
								variant={"ghost"}
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button type={"submit"}>
								Create
							</Button>
						</div>
					</form>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

export { NewGroupDialog };
